<template>
    <div id="about" class="w-100 tc ps-blue pb4" >
        <div class="pa3 f1 b pt4-ns pt2 ">We know insulation.</div>
        <!-- <div class="w-100 cover" :style="{'height': mobile ? '18vh' : '45vh', 'background': mobile ? `url(${mobilePic})` : `url(${desktopPic})`, 'backgroundPosition': mobile ? '100% 0%':''}"></div> -->

        <div class="">
            <img :src="desktopPic"/>
        </div>

        <div class="w-80-ns w-90 mt3 tc center">
            <div class="mt3 center f3-ns f5 tl lh-copy">
                <span class="b">{{info.name}}</span> provides commercial, residential contractors as well as homeowners with all things insulation.
                Professional fiberglass insulation service and support is offered to get the job done right. If you’re undertaking new construction, in need of attic insulation, or noise reducing insulation 
                for your renovation or just need some advice on environmentally friendly or energy efficient products, reach out for a free estimate!
            </div>
        </div>
        
        <!-- <div class=" f3-ns f4 pa3 pb4 mv5-ns mv4">
          <router-link to="/products" class="products-button bg-yellow ps-blue b pa3 br3 link">
          Check out our products!
          </router-link> 
        </div> -->


        <!-- <div class="pa3 f1 b pt4-ns pt2 ">Contact us today for help on your upcoming project!</div> -->
        <div class="b f2-ns f3 mv5">Contact us today for help on your upcoming project!</div>

        <div class="w-80-ns w-90 mt4 pv4 center bg-ps-blue white postcard">
            <div class="w-50-ns w-100 dib tl">
                <div class="dt center" :style="{ 'height': mobile ? '' : '420px'}"> 
                    <div class="dtc v-mid center f3-ns f4 pt2 pb4">
                        <div class="b f3 pa2 f2-ns pb2">{{info.name}}</div>
                        <div class="pa1 f3-ns f5"><a class="link" :href="info.tel"><i class="fa fa-phone mr3" style="font-size:20px"/>{{info.phone}}</a></div>
                        <div class="pa1 f3-ns f5"><a class="link" :href="info.mail"><i class="fa fa-envelope-o mr2"/> {{info.email}}</a></div>
                        <div class="pa1 f3-ns f5"><a class="link" :href="info.directions" target="_blank"><i class="fa fa-map-marker mr3"/> {{info.address}}</a></div>
                    </div>
                </div>
            </div>
            <div class=" w-50-ns w-100 dib">
                <div class="w-90 dt center" :style="{ 'height': mobile ? '' : '420px'}"> 
                    <div class="dtc v-mid">
                        <Form class="br2 white w-100 pv0-ns pv3"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import desktopPic from '@/assets/psstruck-nobg-small2.png'
import mobilePic from '@/assets/psstruck-nobg-small3.png'
import Carousel from '@/components/Carousel'
import Form from '@/components/Form2'
export default {
    name: 'About',
    props: ['info', 'mobile'],
    data: function() {
        return {
            desktopPic,
            mobilePic
        }
    },
    components: {Carousel, Form}
}
</script>

<style scoped>
#about {
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url("https://images.unsplash.com/photo-1516541196182-6bdb0516ed27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2134&q=80");
}
.products-button {
  box-shadow: rgb(15,55,111) 5px 5px;
  opacity: .9;
}

.products-button:hover {
  opacity: 1;
  background: rgb(15,55,111);
  box-shadow:gold 5px 5px;
  color: gold;
  transition: .3s ease;
}

.cover {
    background-position: 0% 25%; 
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;    
    text-align: center;
    margin: auto;
    background-repeat: repeat-x;
    animation: animatedBackground 1.5s linear 1;
}
/* 
@keyframes animatedBackground {
  from {
    background-position: 0% 0%;
  }
  to {
    background-position: 95% 0%;
  }
} */

.postcard a.link:hover {
  background-color: #fff;
  color: #0f376f;
  transition: ease .5s;
  padding: .25rem;
}

.postcard a.link {
    color: #fff;
}

.wrap-input100 {
    border-bottom: 1px solid white !important;
}

.postcard {
  background-image: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.7)), url("../assets/house-banner.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>
